import appApi from '../../../../../../api/app-api';

interface UpdateCourseHoursRequestParams {
  programId: number;
  courseId: number;
  requestId: number;
  newHours: number;
  newJustification: string;
  setLoading: (loading: boolean) => void;
}

export const updateCourseHoursRequest = async ({
  programId,
  courseId,
  requestId,
  newHours,
  newJustification,
  setLoading,
}: UpdateCourseHoursRequestParams): Promise<void> => {
  try {
    setLoading(true);

    const response = await appApi.updateCourseHoursRequest(
      programId,
      courseId,
      requestId,
      newHours,
      newJustification,
    );

    if (!response.data.ok) {
      throw new Error('Failed to update course hours request');
    }

    console.log('Course hours request updated successfully');
  } catch (error) {
    console.error('Error updating course hours request:', error);
    throw error;
  } finally {
    setLoading(false);
  }
};
